// extracted by mini-css-extract-plugin
export default {"list":"List_list__C4mFQ","listItem":"List_listItem__jBfS+"};